import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import FirmsAdmin from './FirmsAdmin'
import PromptsSettings from './PromptsSettings'
import DatabaseMaintenance from './DatabaseMaintenance'
import SourceUpdates from './SourceUpdates'

type SubTabKey = 'firms' | 'prompts' | 'maintenance' | 'updates'

export default function PlatformTab() {
  const { t } = useTranslation()
  const [subTab, setSubTab] = useState<SubTabKey>('firms')

  const subTabs: { key: SubTabKey; label: string }[] = [
    { key: 'firms', label: t('platform.tabs.firms') },
    { key: 'prompts', label: t('platform.tabs.prompts') },
    { key: 'maintenance', label: t('platform.tabs.maintenance') },
    { key: 'updates', label: t('platform.tabs.sourceUpdates') },
  ]

  const subTabClass = (tab: SubTabKey) => `
    px-3 py-1.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap
    ${subTab === tab ? 'bg-primary-100 text-primary-700' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'}
  `

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">{t('platform.title')}</h2>

      <div className="flex gap-2 overflow-x-auto border-b border-gray-200 pb-3">
        {subTabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setSubTab(tab.key)}
            className={subTabClass(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {subTab === 'firms' && <FirmsAdmin />}
      {subTab === 'prompts' && <PromptsSettings />}
      {subTab === 'maintenance' && <DatabaseMaintenance />}
      {subTab === 'updates' && <SourceUpdates />}
    </div>
  )
}
